/**
 * There are 2 selects components for now, at some point the Select.old.tsx and
 * related components will be deprecated, so please use the new version. If you
 * find any problem report it instead of using the old one.
 *
 * Usage:
 *
 * // Accessible Select
 * import { Select } from 'components/Select'
 *
 * // Deprecated Select
 * import Select from 'components/Select'
 */

// Deprecated Select
import Select from './Select.old'
import Option from './Option.styles'
export default Object.assign(Select, {
  Option,
})

// Accessible Select
export * from './Select'

// Styles
export * from './Select.styles'
export * from './Select.styles.old'

export { default as SelectButton } from './SelectButton'
